import { render, staticRenderFns } from "./PageParametersCreate.vue?vue&type=template&id=f3b17a26"
import script from "./PageParametersCreate.vue?vue&type=script&lang=js"
export * from "./PageParametersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports